import { Helmet } from "react-helmet";

export default function AppHelmet({
  title,
  description,
  favicon,
}: {
  title?: string;
  description?: string;
  favicon?: string;
}) {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{title || "GrowthCloud.com"}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href="http://app.growthcloud.com" />
      {favicon && <link rel="icon" type="image/png" href={favicon} />}
    </Helmet>
  );
}
